import { Button } from "@/components/ui/button";
import { LAB_LABELS, LAB_VALUE_LABELS } from "@/components/supplement/supplementConstants";

export const LabsStep = ({ labsOptional, labs, onChange, onBack, onSubmit, saving }) => {
  const entries = Object.entries(labsOptional).filter(([key, values]) => key !== "rule" && key !== "previously_told_low" && Array.isArray(values));
  return (
    <section className="supplement-tool" data-testid="supplement-labs-step">
      <div className="supplement-fields supplement-fields--labs">
        {entries.map(([key, values]) => (
          <label htmlFor={`supplement-lab-${key}`} key={key}>
            <span>{LAB_LABELS[key]}</span>
            <select id={`supplement-lab-${key}`} value={labs[key] || ""} onChange={(event) => onChange(key, event.target.value)} data-testid={`supplement-lab-${key}-select`}>
              <option value="">I don't know</option>
              {values.map((value) => <option key={value} value={value}>{LAB_VALUE_LABELS[value]}</option>)}
            </select>
          </label>
        ))}
      </div>
      <div className="supplement-actions">
        <Button variant="ghost" onClick={onBack} data-testid="supplement-labs-back-button">Back</Button>
        <Button onClick={onSubmit} disabled={saving} className="supplement-primary-action" data-testid="supplement-see-plan-button">See my plan</Button>
      </div>
    </section>
  );
};